import Constant from '@/const';
import axios from 'axios';

const getNurseDiagnose = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/nursediagnose'),
      { params },
    );
    return response.data;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getNurseDiagnose;
